import React, { useEffect, useState } from "react";

const DEFAULT_LOGO =
  "https://static.ambitionbox.com/alpha/community/assets/default-company-placeholder-v2.png";

const logoCache = new Map<string, string>();

const getCompanyLogo = async (companyName: string): Promise<string> => {
  if (!companyName || typeof companyName !== "string") return DEFAULT_LOGO;

  const cleanedName = companyName
    .toLowerCase()
    .replace(/[^a-z0-9]/gi, "")
    .trim();

  if (logoCache.has(cleanedName)) {
    return logoCache.get(cleanedName)!;
  }

  const domain = `${cleanedName}.com`;
  const logoUrl = `https://logo.clearbit.com/${domain}`;

  // Validate the image by attempting to load it
  const isValid = await new Promise<boolean>((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true); // Image exists
    img.onerror = () => resolve(false); // 404 or other error
    img.src = logoUrl;
  });

  const finalUrl = isValid ? logoUrl : DEFAULT_LOGO;
  logoCache.set(cleanedName, finalUrl);
  return finalUrl;
};

const CompanyLogo = ({ companyName }: { companyName: string }) => {
  const [logoUrl, setLogoUrl] = useState<string>("");

  useEffect(() => {
    const fetchLogo = async () => {
      const url = await getCompanyLogo(companyName);
      setLogoUrl(url);
    };
    fetchLogo();
  }, [companyName]);

  return (
    <img
      src={logoUrl}
      alt={companyName}
      style={{
        fontSize: 19,
        marginRight: 4,
        width: 26,
        height: 26,
        borderRadius: "50%",
        objectFit: "cover",
        border: "1px solid #dfdad",
      }}
    />
  );
};

export default CompanyLogo;
